import { ConnectionState } from 'livekit-client'
import { PlaygroundHeader } from './PlaygroundHeader'
import type { AppConfig } from '../../hooks/useConfig'

interface DisconnectedStateProps {
  config: AppConfig
  onConnectClick: () => void
}

export function DisconnectedState({
  config,
  onConnectClick,
}: DisconnectedStateProps) {
  return (
    <div className="h-screen bg-background flex flex-col">
      <div className="px-4">
        <PlaygroundHeader
          title={config.title}
          accentColor={config.settings.theme_color}
          height={56}
          connectionState={ConnectionState.Disconnected}
          onConnectClicked={onConnectClick}
        />
      </div>
      <div className="flex-1 flex items-center justify-center text-muted-foreground">
        <div className="text-center">
          <p className="text-lg mb-4">Connect to join a live session</p>
        </div>
      </div>
    </div>
  )
}
